export var isDevelopment = function () {
    return process.env.NEXT_PUBLIC_APP_ENVIRONMENT === "dev";
};
export var isCI = function () { return process.env.NEXT_PUBLIC_APP_ENVIRONMENT === "CI"; };
export var isTest = function () { return process.env.NEXT_PUBLIC_APP_ENVIRONMENT === "test"; };
export var isProduction = function () {
    return process.env.NEXT_PUBLIC_APP_ENVIRONMENT === "prod";
};
